import React, { useState, useEffect } from "react";
import axios from "axios";
import url from "../../function/url";
import "../company/formstyle.css";
import './JobStreamChangeForm.css';
import Cookies from "js-cookie";
import CompanyNavbar from "../company/CompanyNavbar";
import Swal from "sweetalert2";

const BlacklistForm = () => {
  const [employees, setEmployees] = useState([]); // Store employees with role "Employee"
  const [selectedEmployee, setSelectedEmployee] = useState(""); // ID of selected employee
  const [reason, setReason] = useState(""); // Blacklist reason
  const [message, setMessage] = useState(""); // Success/Error message
  const [error, setError] = useState(""); // Error message for validation


  const [loading, setLoading] = useState(true);
  // Fetch employees with role "Employee" from the backend
  useEffect(() => {
    const logId = Cookies.get("log_id");
    
        if (!logId) {
          setError("User not logged in or session expired. Please log in again.");
          setLoading(false);
          return;
        }
    
        console.log("Log Id :", logId);
    axios
      .get(`${url.path}/employees/`, {
        params: { log_id: logId },
        // withCredentials: true,
        headers: {
          "X-CSRFToken": Cookies.get("csrftoken"),
        },
      })
     
      .then((response) => setEmployees(response.data))
      .catch((error) => {
        console.error("Error fetching employees:", error);
        setError("Failed to fetch employees. Please try again later.");
      });
  }, []);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedEmployee || !reason.trim()) {
      setError("Please select an employee and provide a valid reason.");
      return;
    }

    const data = {
      employee: selectedEmployee,
      reason,
    };

    // Send the blacklist data to the backend
    axios
      .post(`${url.path}/blacklist/`, data)
      
      .then((response) => {
        Toast.fire({
          icon: "success",
          title: "Blacklist request sent successfully.",
        });
        
        setError(""); // Clear any previous errors
        setSelectedEmployee(""); // Reset form
        setReason("");
      })
      .catch((error) => {
        console.error("Error blacklisting employee:", error);
        Toast.fire({
          icon: "error",
          title: "Failed to blacklist employee. Please try again later.",
        });
        // setError("Failed to blacklist employee. Please try again later.");
      });
  };
  const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });

  return (
    <>
    <CompanyNavbar/>
    <div className="page-wrapper">
       <div className="form-container">
       <h1 style={{ fontSize: "30px" }}>Blacklist an Employee</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {message && <p style={{ color: "green" }}>{message}</p>}
      
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {/* Employee Dropdown */}
        <label htmlFor="employee">Select Employee:</label>
        <select
          id="employee"
          value={selectedEmployee}
          onChange={(e) => setSelectedEmployee(e.target.value)}
          required
        >
          <option value="">-- Select Employee --</option>
          {employees.map((employee) => (
            <option key={employee.id} value={employee.id}>
              {employee.Employee_Name} 
            </option>
          ))}
        </select>

        {/* Reason Input */}
        <label htmlFor="reason">Reason for Blacklisting:</label>
        <textarea
          id="reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter the reason for blacklisting the employee"
          rows="4"
          required
        />

        {/* Submit Button */}
        <button type="submit" style={{ padding: "10px", backgroundColor: " #4b0082", color: "#fff", border: "none", cursor: "pointer" }}>
          Blacklist Employee
        </button>
      </form>
       </div>

    </div>
    </>

    
  );
};

export default BlacklistForm;
